import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import { Theme } from '@seedlang/constants';
import OutlineButton from 'components/button/outline_button';
import DeleteAccountModal from 'components/modal/delete_account_modal';

const Wrapper = styled.div`
  p {
    max-width: 500px;
  }
`;

@observer
class AccountDeletion extends React.Component {
  @observable showConfirmDeleteModal = false;

  render() {
    return (
      <Wrapper>
        {
          this.showConfirmDeleteModal &&
          <DeleteAccountModal
            onClose={() => this.showConfirmDeleteModal = false}
            activeStripeSubscriptionExists={this.props.activeStripeSubscriptionExists}
          />
        }
        <h3>Seedlang Account and Data Deletion</h3>
        {
          AppUI.userIsSignedIn &&
          <div>
            <p>
              If you would like to delete your account and all of its associated data, please click the button below.
            </p>
            <OutlineButton
              selectedBackground={Theme.red}
              margin='10px 0 0 0'
              onClick={() => this.showConfirmDeleteModal = true}
            >
              Delete Account
            </OutlineButton>
          </div>
        }
        {
          !AppUI.userIsSignedIn &&
          <div>
            <p>
              You must be signed in in order to delete your account. Please sign in to continue or contact help@seedlang.com for assistance.
            </p>
            <p>
              Once you have signed in, you will only need to click a button in order to delete your account and all of its associated data.
            </p>
          </div>
        }
      </Wrapper>
    );
  }
}

export default AccountDeletion;
